import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "leaderboard" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "place" }
const _hoisted_4 = { class: "userinfo" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "userinfo__content" }
const _hoisted_8 = { class: "username" }
const _hoisted_9 = { class: "reward" }
const _hoisted_10 = {
  key: 0,
  class: "scores"
}
const _hoisted_11 = { class: "text-capitalize-first label" }
const _hoisted_12 = {
  key: 1,
  class: "scores"
}
const _hoisted_13 = { class: "text-capitalize-first label" }
const _hoisted_14 = { class: "score" }

import {useStore} from "vuex";
import {numberFormatter} from "@/service/NumberFormatter";
import {TournamentType} from "@/models/enum/TournamentType";
import TournamentDTO from "@/models/TournamentDTO";
import TournamentParticipantDTO from "@/models/TournamentParticipantDTO";
import PokerCombination from "@/components/PokerCombination.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TournamentLeaderboard',
  props: {
    leaderboard: {},
    tournament: {}
  },
  setup(__props: any) {

const props = __props

const store = useStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.leaderboard, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["leaderboard__item", {current: item.userId === _unref(store).getters.getUser.id}]),
        key: item.place
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.place), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (item.userAvatarUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.userAvatarUrl
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.userLabel), 1),
              _createElementVNode("div", _hoisted_9, [
                _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(item.prize)), 1)
              ])
            ])
          ])
        ]),
        (props.tournament.type === _unref(TournamentType).POKER)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(`poker_combinations.${item.pokerCombination?.combination ?? 'NONE'}`)), 1),
              _createVNode(PokerCombination, {
                pokerCombination: item.pokerCombination
              }, null, 8, ["pokerCombination"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('score')), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(numberFormatter).formatNumber(item.points)), 1)
            ]))
      ], 2))
    }), 128))
  ]))
}
}

})